import React, { PureComponent } from 'react';
import {
  bool, oneOf, string, node,
} from 'prop-types';
import classNames from 'classnames';

const FormStructure = ({
  isHorizontal, label, children, addonLabel,
}) => {
  if (isHorizontal) {
    return (
      <div className="field is-horizontal">
        {label && (
          <div className="field-label">
            <label className="label">{label}</label>
          </div>
        )}
        <div className="field-body">
          <div className="field is-expanded">
            <div className="field">
              <div className="control">{children}</div>
            </div>
          </div>
        </div>
      </div>
    );
  }
  return (
    <div className="field">
      {label && <label className="label">{label}</label>}
      <div className={`field ${addonLabel && 'has-addons'}`}>{children}</div>
    </div>
  );
};

FormStructure.displayName = 'FormStructure';

const FieldWrapper = ({ type, isHorizontal, children }) => {
  if (type === 'select') {
    const selectClasses = classNames('select', {
      'is-fullwidth': isHorizontal,
    });
    return <div className={selectClasses}>{children}</div>;
  }
  return children;
};

FieldWrapper.displayName = 'FieldWrapper';

export default class FieldLayout extends PureComponent {
  static propTypes = {
    type: oneOf(['select', 'text', 'checkbox', 'textarea']),
    isHorizontal: bool,
    label: string,
    children: node,
  };

  render() {
    const {
      type, isHorizontal, label, children, addonLabel,
    } = this.props;
    return (
      <FormStructure
        isHorizontal={isHorizontal}
        label={label}
        addonLabel={addonLabel}
      >
        <FieldWrapper type={type} isHorizontal={isHorizontal}>
          {children}
        </FieldWrapper>
      </FormStructure>
    );
  }
}

FieldLayout.displayName = 'FieldLayout';
